import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { dk, no, sv } from './locales';

export const getLangFromDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('.dk')) return 'dk';
  if (hostname.includes('.se')) return 'sv';
  return 'no';
};

i18n.use(initReactI18next).init({
  resources: {
    no: { translation: no },
    dk: { translation: dk },
    sv: { translation: sv },
  },
  lng: getLangFromDomain(),
  fallbackLng: 'no',
  interpolation: { escapeValue: false },
});

export default i18n;
